import React, { memo } from 'react';
import styles from './dialogSubtitle.module.scss';

const DialogSubtitle = ({ children }) =>
    <div className={styles.dialogTitle}>
        {children}
    </div>

export default memo(DialogSubtitle);